import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createNewUser,
  forgetPassword,
  loginUser,
} from "../../redux/actions/authAction";
import { useNavigate } from "react-router-dom";
import notify from "../useNotifaction";
import { createReview } from "./../../redux/actions/reviewAction";

const AddRateHook = (id) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [rateText, setRateText] = useState("");
  const [rateValue, setRateValue] = useState(0);

  const [loading, setLoading] = useState(true);

  const checkISComplate = rateText !== "" && rateValue !== 0;

  //   const [isRateEmpty, setIsRateEmpty] = useState(true);

  //   useEffect(() => {
  //     if (rateValue === 0 && rateText !== "") {
  //       setIsRateEmpty(false);
  //     } else {
  //       setIsRateEmpty(true);
  //     }
  //   }, [rateText, rateValue]);

  const OnChangeRateText = (e) => {
    setRateText(e.target.value);
  };
  const OnChangeRateValue = (val) => {
    setRateValue(val);
  };
  var user = "";
  if (localStorage.getItem("user") != null)
    user = JSON.parse(localStorage.getItem("user"));

  ///when save rate
  const onSubmit = async () => {
    if (rateText === "") {
      notify("من فضلك اكتب تعليق", "error");
      return;
    }
    setLoading(true);
    await dispatch(
      createReview(id, {
        title: rateText,
        rateings: rateValue,
      })
    );
    setLoading(false);
  };

  const res = useSelector((state) => state.reviewReducer.createView);

  useEffect(() => {
    if (loading === false) {
      if (res) {
        if (res.status === 500) {
          notify("هناك مشكله فى سيرفر", "error");
        } else if (res.status === 401) {
          notify("من فضلك قم بتسجيل الدخول", "error");
        } else if (res.status && res.status === 403) {
          if (res.data.error.length >= 1) {
            res.data.error.forEach((e) => {
              if (e.msg === "Ratings value must be between 1 to 5") {
                notify("لو سمحت ادخل التتقيم  من 1 الى 5", "error");
              } else if (e.msg === "You already created a review before") {
                notify("غير مسموح بادخل  اكثر من تعليق", "error");
              } else {
                notify(e.msg, "error");
              }
            });
          } else {
            notify(" غير مسموح ", "error");
          }
        } else if (res.status === 200) {
          notify("تمت اضافة التقييم بنجاح", "success");
          setTimeout(() => {
            window.location.reload(false);
          }, 1000);
        }
      }
      // else if (res.data.errors && res.data.errors[0].msg === "You already added review on this product") {
      //     notify("لقد قمت باضافة تقييم لهذا المنتج مسبقا", "error")
      // }
    }
  }, [loading]);

  return [
    OnChangeRateText,
    OnChangeRateValue,
    rateText,
    rateValue,
    user,
    onSubmit,
    checkISComplate,
  ];
};

export default AddRateHook;

// if (res.data.error.name === "JsonWebTokenError" || res.data.message === "jwt expired") {
//     notify("غير مسموح بالتقييم", "error")
// }
// else if (res.status && res.status === 403) {
//     if (res.data.message === "You are not allowed to access this route") {
//         notify("غير مسموح للادمن بالتقييم", "error")
//     }
//     if (res.data.error) {
//         // res.data.error.forEach((e) => {
//         //     if (e.msg === "Ratings value must be between 1 to 5") {
//         //         notify("لو سمحت ادخل التتقيم  من 1 الى 5", "error")
//         //     }
//         //     else if (
//         //         e.msg === "You already created a review before") {
//         //         notify("غير مسموح بادخل  اكثر من تعليق", "error")
//         //     } else {
//         //         notify(e.msg, "error")
//         //     }
//         // })
//     }
// } else if (res.data.errors && res.data.errors[0].msg === "You already added review on this product") {
//     notify("لقد قمت باضافة تقييم لهذا المنتج مسبقا", "error")
// } else if (res.status && (res.status === 200 || res.status === 200)) {
//     notify("تمت اضافة التقييم بنجاح", "success")
//     setTimeout(() => {
//         window.location.reload(false)
//     }, 1000);
// }
